import { t } from 'ttag'
import { useContext } from 'react'

import { Globals } from '@h2/globals'
import localOpsSvg from '@h2/assets/svg/blockGraphics/localOps.svg'

import { Promotion } from '../../promotion'

const LocalOpportunities = () => {
  const { hasLocalOpportunities } = useContext(Globals)

  if (hasLocalOpportunities) {
    return (
      <Promotion color="orange" variant="explorer">
        <Promotion.Heading>{t`Discover local opportunities`}</Promotion.Heading>
        <Promotion.Text>{t`Find opportunities to learn and inform your choices.`}</Promotion.Text>
        <Promotion.Button href="/opportunities">{t`Start exploring`}</Promotion.Button>
        <Promotion.Image src={localOpsSvg} />
      </Promotion>
    )
  }

  return <div style={{ width: '100%' }}></div>
}

export { LocalOpportunities }
